import { render, staticRenderFns } from "./TicketsReviewDot.vue?vue&type=template&id=9a881e22&scoped=true&"
import script from "./TicketsReviewDot.vue?vue&type=script&lang=ts&"
export * from "./TicketsReviewDot.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsReviewDot.vue?vue&type=style&index=0&id=9a881e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a881e22",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VContainer,VDivider,VRow,VSkeletonLoader})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a881e22')) {
      api.createRecord('9a881e22', component.options)
    } else {
      api.reload('9a881e22', component.options)
    }
    module.hot.accept("./TicketsReviewDot.vue?vue&type=template&id=9a881e22&scoped=true&", function () {
      api.rerender('9a881e22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/dashboard/components/TicketsReviewDot.vue"
export default component.exports